import { json } from '@remix-run/node'
import { type MetaFunction, useLoaderData } from '@remix-run/react'
import { GeneralErrorBoundary } from '#app/components/error-boundary.tsx'
import { GalleryImagesSlider } from '#app/components/image-sliders.tsx'
import { prisma } from '#app/utils/db.server.ts'

export async function loader() {
	const baseGallery = await prisma.gallery.findUnique({
		where: { id: 'base-gallery' },
		select: {
			id: true,
			name: true,
			images: {
				select: {
					id: true,
					altText: true,
				},
			},
		},
	})

	const naDvoreGallery = await prisma.gallery.findUnique({
		where: { id: 'cm66pnvis0023ng0ze6n2gn9i' },
		select: {
			id: true,
			name: true,
			images: {
				select: {
					id: true,
					altText: true,
				},
			},
		},
	})

	const restauraceGallery = await prisma.gallery.findUnique({
		where: { id: 'cm66psa2u0024ng0zb10qwxin' },
		select: {
			id: true,
			name: true,
			images: {
				select: {
					id: true,
					altText: true,
				},
			},
		},
	})

	const lyzarnaKolarnaGallery = await prisma.gallery.findUnique({
		where: { id: 'cmvauy5r200027gzpoz9336ah' },
		select: {
			id: true,
			name: true,
			images: {
				select: {
					id: true,
					altText: true,
				},
			},
		},
	})

	if (!baseGallery && !naDvoreGallery && !restauraceGallery && !lyzarnaKolarnaGallery) {
		throw new Response('not found', { status: 404 })
	}

	return json({ baseGallery, naDvoreGallery, restauraceGallery, lyzarnaKolarnaGallery})
}

export default function RoomsIndex() {
	const data = useLoaderData<typeof loader>()
	// const baseGallery = data.baseGallery
	const baseGalleryImages = data.baseGallery?.images
	const naDvoreGalleryImages = data.naDvoreGallery?.images
	const restauraceGalleryImages = data.restauraceGallery?.images
	const lyzarnaKolarnaGalleryImages = data.lyzarnaKolarnaGallery?.images

	return (
		<>
			{baseGalleryImages?.length ? (
				<div className="mb-6 rounded-2xl bg-black/60 px-4 text-white md:my-6 pt-8 pb-12 md:pt-12 md:pb-20 md:px-6">
					<h1 className="text-center text-h3 lg:text-h2 capitalize text-white mb-8">Galerie</h1>
					<GalleryImagesSlider images={baseGalleryImages} />
				</div>
			) : null}

			{naDvoreGalleryImages?.length ? (
				<div className="mb-6 rounded-2xl bg-black/60 px-4 text-white md:my-6 pt-8 pb-12 md:pt-12 md:pb-20 md:px-6">
					<h1 className="text-center text-h3 lg:text-h2 capitalize text-white mb-8">Na Dvoře</h1>

					<GalleryImagesSlider images={naDvoreGalleryImages} />
				</div>
			) : null}

			{restauraceGalleryImages?.length ? (
				<div className="mb-6 rounded-2xl bg-black/60 px-4 text-white md:my-6 pt-8 pb-12 md:pt-12 md:pb-20 md:px-6">
					<h1 className="text-center text-h3 lg:text-h2 capitalize text-white mb-8">Restaurace</h1>

					<GalleryImagesSlider images={restauraceGalleryImages} />
				</div>
			) : null}

			{lyzarnaKolarnaGalleryImages?.length ? (
				<div className="mb-6 rounded-2xl bg-black/60 px-4 text-white md:my-6 pt-8 pb-12 md:pt-12 md:pb-20 md:px-6">
					<h1 className="text-center text-h3 lg:text-h2 capitalize text-white mb-8">Lyžárna a kolárna</h1>

					<GalleryImagesSlider images={lyzarnaKolarnaGalleryImages} />
				</div>
			) : null}
		</>
	)
}

export function ErrorBoundary() {
	return <GeneralErrorBoundary />
}

export const meta: MetaFunction = () => [
	{ title: 'Galerie | Penzion Sklář' }
]
